import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { DataGridTypes } from '../entities';
import { exportDataGrid } from 'devextreme/excel_exporter';
export async function onExporting(e: DataGridTypes.ExportingEvent, name: string) {
	const workbook = new Workbook();
	const worksheet = workbook.addWorksheet('Main sheet');

	await exportDataGrid({
		component: e.component,
		worksheet: worksheet,
		autoFilterEnabled: true
	});

	const buffer = await workbook.xlsx.writeBuffer();

	saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${name}.xlsx`);
}
